import * as React from 'react';

import type SiblingSubjobVM from 'ab-viewModels/workRequest/siblingSubjob.viewModel';

import { Button } from '@acceligentllc/storybook';

import Dropdown from 'af-components/Controls/Dropdown';
import CustomModal from 'af-components/CustomModal';

function filterSubJob(subJob: Nullable<SiblingSubjobVM>, text: string) {
	return subJob?.jobCode.includes(text) ?? false;
}

interface OwnProps {
	subJobs: SiblingSubjobVM[];
	showModal: boolean;
	closeModal: () => void;
	onSubmit: (subJob: SiblingSubjobVM) => void;
}

type Props = OwnProps;

const AssignAllToSubJobModal: React.FC<Props> = (props) => {
	const { closeModal, showModal, subJobs, onSubmit } = props;

	const [selectedSubJob, setSelectedSubJob] = React.useState<Nullable<SiblingSubjobVM>>(null);

	// Used to reset selectedSubJob when modal closes
	React.useEffect(() => {
		if (!showModal) {
			setSelectedSubJob(null);
		}
	}, [showModal]);

	const handleAssign = React.useCallback(() => {
		if (!selectedSubJob) {
			return;
		}
		onSubmit(selectedSubJob);
		closeModal();
	}, [closeModal, onSubmit, selectedSubJob]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="info"
			showModal={showModal}
			size="sm"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Assign all billable work to Sub-job?"
			/>
			<CustomModal.Body>
				<Dropdown<SiblingSubjobVM>
					filterable={true}
					filterBy={filterSubJob}
					fixed={true}
					label="Assign all billable work to:"
					labelKey="jobCode"
					onValueChange={setSelectedSubJob}
					options={subJobs}
					placeholder="Select Sub-job"
					withBorder={true}
					withCaret={true}
				/>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Cancel"
					onClick={closeModal}
					style="secondary"
				/>
				<Button
					disabled={!selectedSubJob}
					label="Assign"
					onClick={handleAssign}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default AssignAllToSubJobModal;
